export function getTranslation(
    translations: Record<string, string>,
    key: string,
    defaultText: string
): string {
    return translations[key] || defaultText;
}